import { hasRoomInviteFields, roomInviteHomePath, ROOM_INVITE_REGISTRY } from "./RoomInvite";

export function roomInviteAuthReturnPath(backTo, registry = ROOM_INVITE_REGISTRY) {
  if (typeof backTo !== "string" || !backTo.startsWith("/home?")) return null;
  return roomInviteHomePath(backTo.slice("/home".length), registry, true);
}

export function roomInviteRegistrationAgentRid(backTo, storedAgentRid, registry = ROOM_INVITE_REGISTRY) {
  const home = roomInviteAuthReturnPath(backTo, registry);
  if (home) return new URLSearchParams(home.split("?")[1]).get("aid") || "";
  // A malformed invitation must not inherit an unrelated cached commission parent.
  if (typeof backTo === "string" && backTo.startsWith("/home?") && hasRoomInviteFields(backTo.slice(5), registry)) return "";
  return storedAgentRid || "";
}
